import Icon from "./Icon";

/**
 * LoadingOverlay component
 *
 * Displays a loading, success, or error overlay with a message.
 * - `overlayType = "loading"` shows a spinning loader
 * - `overlayType = "success"` shows a success icon
 * - `overlayType = "error"` shows an error icon
 *
 * Commonly used for async operations such as reading cards, uploading,
 * or fetching data.
 *
 * @param {object} props
 * @param {"loading"|"success"|"error"} props.overlayType
 *   Determines which overlay icon to show. Defaults to `"loading"`.
 *
 * @param {string} props.message
 *   The message displayed below the icon. Defaults to `"กำลังโหลด"`.
 */
export default function LoadingOverlay({
  overlayType = "loading",
  message = "กำลังโหลด",
}) {

  const iconNameMap = {
    success: "check-circle",
    error: "x",
  };

  const iconClassNameMap = {
    success: "text-main-icon-accented-success",
    error: "text-main-icon-accented-error",
  }

  return (
    <div className="w-[120px] px-5 pt-6 pb-5 gap-5 rounded-xl bg-main-background-system-default flex flex-col items-center justify-center">
      {overlayType === "loading" ? (
        <div className="w-8 h-8 flex items-center justify-center">
          <div className="w-scale-lg h-scale-lg border-[6px] border-main-icon-accented-primary border-t-transparent rounded-full animate-spin"></div>
        </div>
      ) : (
        <Icon name={iconNameMap[overlayType]} size="xl" className={iconClassNameMap[overlayType]} />
      )}

      <p className="font-ui font-body text-body-base text-main-typography-system-default text-center">
        {message}
      </p>
    </div>
  );
}
